import React from 'react';
import BlueThemeBusinessForm from './components/BlueThemeBusinessForm';

function BlueFormDemo() {
  return (
    <div>
      <BlueThemeBusinessForm />
    </div>
  );
}

export default BlueFormDemo;